import React from 'react';
import PropTypes from 'prop-types';
import { Grid } from '@material-ui/core';
import { policyType as PolicyTypes } from '@ourbranch/lookups';
import { isFarmBasedPolicyType } from '@ourbranch/farm-utils';

import { NotificationCard } from 'core/components/notification-card';
import { isUnofferedAutoPlan } from 'core/helpers/auto-direct-bill';
import { farmDirectMonthlyNote, isFarmDirectMonthlyPlan } from 'common/helpers/farm-helpers';

// The mutuals don't sell Direct Bill monthly auto (#36200). A migrated policy that carries it anyway
// keeps its plan visible on the Billing tab, with this note asking staff to move it to an offered plan.
// Farm doesn't sell it either, but migrated farm policies keep it (#37291), so their note says the plan
// can stay and how to move the member to automatic payments. It shows only while the form still holds the
// plan the policy was saved with, so a policy edited into Direct + Monthly isn't told it may keep it.
const UnofferedPlanNote = ({ policyType, paymentMethod, paymentType, savedPlan }) => {
  const formPlan = { method: paymentMethod, type: paymentType };
  if (
    isFarmBasedPolicyType(policyType) &&
    isFarmDirectMonthlyPlan(formPlan) &&
    Boolean(savedPlan) &&
    isFarmDirectMonthlyPlan(savedPlan)
  ) {
    return (
      <Grid item xs={12}>
        <NotificationCard type="light" header={farmDirectMonthlyNote.header}>
          {farmDirectMonthlyNote.body}
        </NotificationCard>
      </Grid>
    );
  }

  if (policyType !== PolicyTypes.Auto || !isUnofferedAutoPlan(formPlan)) {
    return null;
  }

  return (
    <Grid item xs={12}>
      <NotificationCard type="warning" header="Direct Bill monthly is not an offered auto payment plan">
        This policy's payment plan must be changed. Choose Direct with 2 payments or One Time, or switch to an automated
        payment method to pay monthly.
      </NotificationCard>
    </Grid>
  );
};

UnofferedPlanNote.propTypes = {
  policyType: PropTypes.string,
  paymentMethod: PropTypes.string,
  paymentType: PropTypes.string,
  // The plan stored on the policy ({ method, type }); the farm note needs it to tell a migrated plan from an edit.
  savedPlan: PropTypes.shape({ method: PropTypes.string, type: PropTypes.string })
};

export default UnofferedPlanNote;
